import { render, staticRenderFns } from "./custom-field.vue?vue&type=template&id=6366fcda&scoped=true"
import script from "./custom-field.vue?vue&type=script&lang=js"
export * from "./custom-field.vue?vue&type=script&lang=js"
import style0 from "./custom-field.vue?vue&type=style&index=0&id=6366fcda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366fcda",
  null
  
)

export default component.exports